module.exports = __webpack_public_path__ + "img/cloth_g3_pants_10.e41200b5.svg";